/*
 * Edit Job Comment Connector
 */

import { TFunction } from 'i18next';
import { connect } from 'react-redux';

import { IinitialState } from '../../reducers';
import {
    updateJobComment,
    toggleEditJobCommentModal,
    addJobComment,
    setSelectedJobComment,
    deleteJobComment
} from '../../actions/manageJobCommentsActions';
import { EditJobCommentForm } from './EditJobCommentForm';
import { RouteComponentProps } from 'react-router';
import { selectDeficiencyCodesByStandardID } from '../../reducers/manageJobCommentsReducer';
import { initialFacility } from '../../reducers/initialState';
import { selectIsLoading } from '../../reducers/commonReducers';
import { selectIsJobReadOnly } from '../../reducers/commonSelectors';
import { isJobUnderReview } from '../../utils/reviewFlow';

interface Iprops extends RouteComponentProps<Record<string, never>> {
    colorButton: any;
    t: TFunction;
}

const mapStateToProps = (state: IinitialState, ownProps: Iprops) => {
    const selectedJob = state.manageJob.selectedJob;
    const facility = state.facilities.facilitiesByID[selectedJob.facilityID] || initialFacility;
    const { showEditJobCommentModal, selectedJobComment, deficiencyCodesByID } = state.manageJobComment;
    const filteredDeficiencyCodes = selectDeficiencyCodesByStandardID(deficiencyCodesByID, facility.standardID);
    const isNewComment = !selectedJobComment.id;
    const jobIsInReviewFlow = isJobUnderReview(selectedJob);
    const commentWithDefault = isNewComment && jobIsInReviewFlow
        ? { ...selectedJobComment, isInternal: true }
        : selectedJobComment;
    return {
        user: state.user,
        loading: selectIsLoading(state),
        showModal: showEditJobCommentModal,
        selectedJobComment: commentWithDefault,
        deficiencyCodesByID: filteredDeficiencyCodes,
        jobID: selectedJob.id,
        installBaseID: '',
        isJobReadOnly: selectIsJobReadOnly(state)
    };
};

export const EditJobCommentContainer = connect(mapStateToProps, {
    updateJobComment,
    toggleEditJobCommentModal,
    addJobComment,
    setSelectedJobComment,
    deleteJobComment
})(EditJobCommentForm);
